// Services Component
// Showcases service offerings with clear CTAs toward contact

import React from 'react';
import './Services.css';
import { getServicesContent } from '../utils/contentLoader';
import { buildContactPrefillHash, navigateToContactPrefill } from '../constants';

function Services() {
  const content = getServicesContent();
  const services = content?.items || [];
  const handleServiceCtaClick = (e, serviceId) => {
    e.preventDefault();
    navigateToContactPrefill({ service: serviceId });
  };

  return (
    <section id="services" className="services">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">{content?.title || "Services"}</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">
            {content?.subtitle || "How I can help your project succeed"}
          </p>
        </div>

        <div className="services-grid">
          {services.map((service) => (
            <div key={service.id} className="service-card">
              <div className="service-icon">
                <i className={service.icon}></i>
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <a
                href={buildContactPrefillHash({ service: service.id })}
                className="service-cta"
                onClick={(e) => handleServiceCtaClick(e, service.id)}
              >
                {service.cta || "Get Started"} <span className="service-cta-arrow">&rarr;</span>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
